import { Button } from "@/components/ui/button";
import { FileText, Trash2 } from "lucide-react";

// Shared View/Delete row for uploaded documents (Employee/Asset/Site
// masters) — mirrors the pattern already working in Vendor Master's
// VendorDocumentsSection (file chip + inline View + role-gated Delete).
export function DocumentActionRow({ testId, label, filename, meta, canDelete, busy, onView, onDelete }) {
  return (
    <div
      className="flex items-center justify-between gap-2 text-xs bg-slate-50 border border-slate-200 rounded px-3 py-2"
      data-testid={testId}
    >
      <button
        type="button"
        onClick={onView}
        className="flex items-center gap-2 text-left text-amber-700 hover:underline min-w-0"
        data-testid={`${testId}-view`}
      >
        <FileText className="h-3.5 w-3.5 flex-shrink-0" />
        <span className="truncate">
          <span className="font-medium">{label}</span>
          {filename ? ` — ${filename}` : ""}
        </span>
      </button>
      <div className="flex items-center gap-2 flex-shrink-0 text-slate-400">
        {meta && <span>{meta}</span>}
        {canDelete && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="h-6 w-6 p-0 text-red-500 hover:text-red-700"
            disabled={busy}
            onClick={onDelete}
            data-testid={`${testId}-delete`}
          >
            <Trash2 className="h-3.5 w-3.5" />
          </Button>
        )}
      </div>
    </div>
  );
}
